import React from "react";
import AntdComment, {CommentProps} from 'antd/lib/comment';
import { withError} from '@fishx/tracker';

const Comment: React.FC<CommentProps>  = (props) => <AntdComment {...props} />
Comment.displayName = 'Comment';
export default withError(Comment);




// WEBPACK FOOTER //
// ./src/components/comment/index.tsx